import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IonicPage, NavController } from 'ionic-angular';

// @IonicPage()
@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html'
})
export class TabsPage {

  constructor(public navCtrl: NavController, public translateService: TranslateService) {
   
  }
}



// WEBPACK FOOTER //
// ./src/pages/aproval_erp/tabs/tabs.ts